<div class="exception-body accessdenied-page">

    <div class="scroll-content no-padding-right">
        <div class="exception-type">
            <img src="../../../../assets/layout/images/error.svg">
        </div>

        <div class="card exception-panel">
            <em class="material-icons">&#xE32A;</em>
            <h1>Forbidden</h1>
            <div class="exception-detail">You are not authorized to access {{errorService.data403 ? errorService.data403.targetRouteName : 'this resource'}}.</div>
            <a routerLink="/" class="ui-button secondary">
                <span class="ui-button-text">Homepage</span>
            </a>
        </div>
    </div>
</div>
